module.exports = __webpack_public_path__ + "static/img/mobile-img-04@m.4280b71.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/serveone/mobile-img-04@m.png
// module id = OUYD
// module chunks = 0